import { MemoryRouter as Router, Routes, Route } from 'react-router-dom';
import React, { useContext, useEffect, useState } from 'react';

import Main from '../Main';
import Login from '../Login';
import Header from '../Header';
import ChatBar from '../OnlineChat/ChatBar';
import OnlineChat from '../OnlineChat';
import Cookies from 'js-cookie';
import { AdminContext } from '../../context/AdminContext';
import Api from '../../api';
import Loader from '../Loader';
import SettingPart from '../SettingPart';
import ChooseLanguage from '../../functions/chooseLanguage';
import CheckToken from '../../functions/CheckToken';
import FileSection from '../FileSection';
import CenterModal from '../CenterModal';
import CookieFunction from '../../functions/cookieFunction';
import HiddenAudioPlayer from '../HiddenAudioPlayer';
import ZoomModalContent from '../ZoomModalContent';
import ActiveChatInfo from '../ActiveChatInfo';
import Splash from '../Splash';
import SettingModal from '../SettingModal';

import moment from 'moment';
import CraeteGroupModal from '../CreateGroupModal';
import UseWindowDimensions from '../../functions/UseWindowDimensions';
import SignUp from '../SignUp';
import ForgetPassword from '../ForgetPassword';
import ToolbarIcons from '../../icons/toolbar';
import config from '../../api/global';

// import { Helmet } from 'react-helmet';

// import firebase from 'firebase/app';
// import 'firebase/messaging';
// import 'firebase/auth';
// import 'firebase/database';
// import SeoHead from '../SeoHead';

export default function Layout({ electron }) {
  const {
    userInfo,
    setUserInfo,
    setVideoChatSize,
    setVideoType,
    setImageType,
    imageType,
    videotype,
    showUsers,
    setShowUsers,
    setShowAbsolute,
    activeUser,
    setActiveUser,
    userChannelId,
    setUserChannelId,
    themeColor,
    setThemeColor,
    themeMode,
    setThemeMode,
    content,
    setContent,
    direction,
    setDirection,
    setLang,
    lang,
    privateUsers,
    setPrivateUsers,
    fileType,
    setFileType,
    setActiveAudio,
    setActiveMessage,
    activeMessageAudio,
    openZoomModal,
    setOpenZoomModal,
    zoomContent,
    setZoomeContent,
    downloadedFiles,
    setDownloadedFiles,
    showFiles,
    setShowFiles,
    openSettingModal,
    setOpenSettingModal,
    bg,
    setBg,
    setBackScale,
    openCreateGroup,
    setOpenCreateGroup,
    setGroupState,
    trigger,
    setTrigger,
    isElectron,
    setIsElectron,

    triggerOff,
    category,

    isDesktop,
    isMobile,
    switchChannelId,
    modalInputValue,
    setModalInputValue,
    notificationModal,
    setNotificationModal,

    openPlaylistModal,
    setOpenPlayListModal,

    setCorrectTypeSrt,
    setSrtSize,
    setSrtType,
    setFavoriteChannelsContex,

    setCorrectTypeImage,
    setVideoUploaded,
    uploadLevel,
    setUploadLevel,
    login,
    paymentInfo,
    notificationCount,
    setNotificationCount,

    videoType,

    musicExtension,
    setMusicExtension,
    videoSize,
    setVideoSize,
    setCorrectMusicType,
    setPaymentChannelList,
    setPaymentTypeList,
    setPaymentStatusList,
    setChannelPaymentSettingActive,
    countries,
    setCountries,
  } = useContext(AdminContext);
  useEffect(() => {
    setIsElectron(electron);
  }, [electron]);

  console.log('pppp', isElectron);
  // const [loginModal, setLoginModal] = useState(false);
  // const [signUpModal, setSignUpModal] = useState(false);
  // const [forgetPasswordModal, setForgetPasswordModal] = useState(false);
  const [KidzyLogin, setKidzyLogin] = useState(false);
  const [users, setUsers] = useState([]);

  const [loadingUsers, setloadingUsers] = useState(false);
  const [splashState, setSplashState] = useState(true);
  const [onlineStatusLayout, setOnlineStatusLayout] = useState(true);
  const { width, height } = UseWindowDimensions();
  const [level1, setLevel1] = useState(true);
  const [level2, setLevel2] = useState(false);
  const [level3, setLevel3] = useState(false);
  const [level4, setLevel4] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [loginModal, setLoginModal] = useState(true);
  const [signupModal, setSignUpModal] = useState(false);
  const [forgetPasswordModal, setForgetPasswordModal] = useState(false);

  const [forgetlevel1, setforgetLevel1] = useState(false);
  const [forgetlevel2, setforgetLevel2] = useState(false);
  const [forgetlevel3, setforgetLevel3] = useState(true);

  const [showErrorAfterLoading, setShowErrorAfterLoading] = useState(false);

  useEffect(() => {
    setShowUsers(width < 650 && userChannelId?.length != 0 ? false : true);
    setShowAbsolute(width < 650 && userChannelId?.length != 0 ? false : true);
  }, [width]);
  console.log('userchannelId', userChannelId);
  useEffect(() => {
    setInterval(() => {
      // updateOnlineStatus();
      setOnlineStatusLayout(navigator.onLine);
    }, 3000);
  }, [navigator.onLine]);

  // const [showFiles, setShowFiles] = useState(false);
  // const firebase = require('firebase/app');
  // require('firebase/messaging');
  // const config = {
  //   apiKey: 'AIzaSyA_k8EaRmFe-yRRtOnujPlkhzEJSLGSdmI',
  //   authDomain: 'chatapplication-98227.firebaseapp.com',
  //   projectId: 'chatapplication-98227',
  //   storageBucket: 'chatapplication-98227.appspot.com',
  //   messagingSenderId: '1044602413717',
  //   appId: '1:1044602413717:web:b88c0e6b5fc9e39933719c',
  //   measurementId: 'G-HGPYJEB14K',
  // };
  // const auth = firebase.auth();
  // firebase.initializeApp(config);
  // const messaging = firebase.messaging();

  // async function requestNotificationPermission() {
  //   const permission = await Notification.requestPermission();
  //   if (permission === 'granted') {
  //     const token = await messaging.getToken();
  //     console.log('FCM token:', token);
  //   }
  // }

  useEffect(() => {
    // window.electron.ipcRenderer.on('push-registration', () => {
    //   firebase
    //     .messaging()
    //     .requestPermission()
    //     .then((token) => {
    //       console.log('=========', token);
    //       // alert('h');
    //     })
    //     .catch((err) => {});
    // });
    // getSignInfo();
    if (CookieFunction('get', 'ochattColor') != undefined) {
      setThemeColor(CookieFunction('get', 'ochattColor'));
    } else {
      CookieFunction('set', 'ochattColor', 'green', () => {
        setThemeColor(CookieFunction('get', 'ochattColor'));
      });
    }

    if (CookieFunction('get', 'ochattMode') != undefined) {
      setThemeMode(CookieFunction('get', 'ochattMode'));
    } else {
      CookieFunction('set', 'ochattMode', 'dark', () => {
        setThemeMode(CookieFunction('get', 'ochattMode'));
      });
    }

    if (CookieFunction('get', 'ochattLang') != undefined) {
      setContent(ChooseLanguage(CookieFunction('get', 'ochattLang'))?.content);
      setDirection(ChooseLanguage(CookieFunction('get', 'ochattLang'))?.dir);
      setLang(CookieFunction('get', 'ochattLang'));
      let lang = ChooseLanguage(CookieFunction('get', 'ochattLang'));
      moment.locale(`${lang}`);
    } else {
      CookieFunction('set', 'ochattLang', 'en', () => {
        setContent(
          ChooseLanguage(CookieFunction('get', 'ochattLang'))?.content
        );
        setDirection(ChooseLanguage(CookieFunction('get', 'ochattLang'))?.dir);
        setLang('en');
        ChooseLanguage('en');
      });
    }

    if (CookieFunction('get', 'ochattBg') != undefined) {
      setBg(CookieFunction('get', 'ochattBg'));
    } else {
      CookieFunction('set', 'ochattBg', '0', () => {
        setBg('0');
      });
    }

    if (CookieFunction('get', 'backScale') != undefined) {
      setBackScale(CookieFunction('get', 'backScale'));
    } else {
      CookieFunction('set', 'backScale', '41', () => {
        setBackScale('41');
      });
    }
    //   if (typeof window !== 'undefined' && typeof document !== 'undefined') {
    let isLogin = CheckToken(CookieFunction('get', 'ochattToken'));
    console.log('islogin', isLogin);
    console.log(
      'udata',
      CookieFunction('get', 'ochattToken'),
      CookieFunction('get', 'userAuthOchatt'),
      CookieFunction('get', 'ochattColor')
    );

    Api.coutryList()
      .then((res) => {
        console.log('countries', res);
        setCountries(res?.data?.response);
      })
      .catch((err) => {});
    if (isLogin) {
      config.udata = CookieFunction('get', 'ochattToken');
      Api.checkLogin().then((res) => {
        if (res.data.response.status == 403 && isLogin) {
          exitFunction();
        } else {
          userInfoFunction();
        }
      });
    }
    setTimeout(() => {
      setSplashState(false);
    }, 3000);
    // window.electron.ipcRenderer.on('app-will-close', (event) => {
    //   // do something before app closes
    //   // });
    //   // alert('1');
    //   // window.electron.ipcRenderer.once('if-close', (event, data) => {

    //   console.log('hello', socketRef, userChannelId);

    //   if (token == undefined || !token) {
    //     setUserChannelId('');
    //     window.electron.ipcRenderer.sendMessage('acceptClose', []);
    //   }
    // });
    window.electron && window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.electron && window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  function handleKeyDown(e) {
    if (e.altKey) {
      e.preventDefault();
    }
  }
  useEffect(() => {
    if (onlineStatusLayout) {
      userInfoFunction();
    }
  }, [onlineStatusLayout]);

  if (isElectron && window.electron) {
    useEffect(() => {
      let isLogin = CheckToken(CookieFunction('get', 'ochattToken'));
      if (isLogin == undefined || !isLogin) {
        window.electron.ipcRenderer.on('app-will-close', (event) => {
          console.log('hello', userChannelId);

          setUserChannelId('');
          window.electron.ipcRenderer.sendMessage('acceptClose', []);
        });
      }
    }, [window.electron.ipcRenderer]);
  }
  //   useEffect(() => {
  //     if (runEffect) {
  //       console.log("running");
  //       setRunEffect(false);
  //     }
  //   }, [runEffect]);

  //   return {
  //     run: () => {
  //       setRunEffect(true);
  //     }
  //   };
  // }

  useEffect(() => {
    setContent(ChooseLanguage(lang)?.content);
    setDirection(ChooseLanguage(lang)?.dir);
  }, [lang]);

  useEffect(() => {}, [showUsers, userChannelId]);

  useEffect(() => {
    if (trigger == 'updateProfile') {
      updateUserInfo();
      setTrigger('');
    }
  }, [trigger]);
  const updateUserInfo = () => {
    Api.userInfo()
      .then((res) => {
        setUserInfo(res.data.response);
        setloadingUsers(false);
      })
      .catch((err) => {});
  };

  console.log('videotypeis', videoType);
  const handleCloseUpload = () => {
    videoForm?.current?.reset();

    setVideoUploaded(false);
    if (cancelFileUpload.current) {
      cancelFileUpload.current('user has canceled upload');
    }
    setUploadLevel(1);
    setModalInputValue({});
    setTrigger('');
  };
  const userInfoFunction = () => {
    // const chId = Cookies?.get('userAuthOchatt');
    const chId = CookieFunction('get', 'userAuthOchatt');
    // let CookieFunction('get', 'ochattToken'),
    setloadingUsers(true);
    Api.userInfo()
      .then((res) => {
        setUserInfo(res.data.response);

        setloadingUsers(false);
        setShowErrorAfterLoading(false);
        // console.log(h)

        // setVideoType(res.data.response.videoExtension);
        // setImageType(res.data.response.imageExtension);
        // setVideoChatSize(res.data.response.sizeVideoChat);
      })
      .catch((err) => {
        setloadingUsers(false);
        setShowErrorAfterLoading(true);
      });
    Api.fileTypes()
      .then((res) => {
        console.log('resssssis', res);
        setFileType(res.data.response);
        setVideoChatSize(res.data.responseSize.fileSize);
      })
      .catch((err) => {});

    if (userChannelId?.length == 0) {
      Api.privateChatUsersChat()
        .then((res) => {})
        .catch((err) => {});
    }
  };

  console.log('fileType', fileType);
  const exitFunction = () => {
    Api.logOutChat()
      .then((res) => {
        CookieFunction('remove', 'ochattToken');
        CookieFunction('remove', 'userAuthOchatt');
        CookieFunction('remove', 'userName');
        window?.location?.reload();
      })
      .catch((err) => {});
  };
  const token = CookieFunction('get', 'ochattToken');
  console.log('token==', token, userInfo, loadingUsers);
  return (
    // <div>hhhh</div>

    <React.Fragment>
      <Main className={`${direction} relative`}>
        {token == undefined || !token ? (
          <React.Fragment>
            {splashState ? (
              <Splash content={content} />
            ) : (
              <React.Fragment>
                {loginModal && (
                  <Login
                    setLoginModal={setLoginModal}
                    setSignUpModal={setSignUpModal}
                    setForgetPasswordModal={setForgetPasswordModal}
                    setKidzyLogin={setKidzyLogin}
                    content={content}
                  />
                )}
                {signupModal && (
                  <SignUp
                    setLoginModal={() => {
                      setLoginModal(true);
                      setSignUpModal(false);
                      setLevel1(true);
                      setLevel2(false);
                      setLevel3(false);
                      setforgetLevel1(true);
                      setforgetLevel2(false);
                      setforgetLevel3(false);
                    }}
                    setSignUpModal={setSignUpModal}
                    level3={level3}
                    setLevel3={setLevel3}
                    level1={level1}
                    setLevel1={setLevel1}
                    level2={level2}
                    setLevel2={setLevel2}
                    content={content}
                  />
                )}
                {forgetPasswordModal && (
                  <ForgetPassword
                    setLoginModal={() => {
                      setLoginModal(true);
                      setForgetPasswordModal(false);
                      setLevel1(true);
                      setLevel2(false);
                      setLevel3(false);
                      setforgetLevel1(true);
                      setforgetLevel2(false);
                      setforgetLevel3(false);
                    }}
                    setSignUpModal={setSignUpModal}
                    setForgetPasswordModal={setForgetPasswordModal}
                    conetnt={content}
                  />
                )}
              </React.Fragment>
            )}
          </React.Fragment>
        ) : (
          <React.Fragment>
            {loadingUsers ? (
              <>
                <Header
                  content={content}
                  exitFunction={exitFunction}
                  showExitButton={true}
                  setShowFiles={setShowFiles}
                  showFiles={showFiles}
                ></Header>
                {!onlineStatusLayout && (
                  <div className={`${'connectionError'} topError`}>
                    {content.offlineText}
                  </div>
                )}
                <Loader width={`w-full h-400px `} />
              </>
            ) : (
              <>
                {showErrorAfterLoading == false ? (
                  <>
                    <>
                      <>
                        <OnlineChat
                          closeModal={() => {
                            localStorage.removeItem('userName');
                          }}
                          setShowUsers={setShowUsers}
                          users={users}
                          showUsers={showUsers}
                          setUsers={setUsers}
                          privateUsers={privateUsers}
                          setPrivateUsers={setPrivateUsers}
                          loadingUsers={loadingUsers}
                          setloadingUsers={setloadingUsers}
                          content={content}
                          direction={direction}
                          exitFunction={exitFunction}
                          showExitButton={true}
                          setShowFiles={setShowFiles}
                          showFiles={showFiles}
                        />
                      </>
                    </>
                    {openZoomModal && (
                      <CenterModal
                        handleShowModal={() => {
                          setOpenZoomModal(false);
                          setZoomeContent();
                          if (activeMessageAudio?.length != 0) {
                            setActiveMessage(activeMessageAudio);
                          }
                        }}
                      >
                        <ZoomModalContent
                          zoomContent={zoomContent}
                          downloadedFiles={downloadedFiles}
                          setDownloadedFiles={setDownloadedFiles}
                          chatBody={true}
                        />
                      </CenterModal>
                    )}
                  </>
                ) : (
                  <div
                    className={`flex flex-row justify-center items-center w-full m-auto cursor-pointer ltr`}
                    onClick={() => {
                      window.location.reload();
                    }}
                  >
                    <p>{content?.reload}</p>{' '}
                    <ToolbarIcons.RefreshIcon
                      fill={'#999'}
                      className="flex flex-col justify-center items-center rotate-[180] reloadMargin"
                      width={'20px'}
                      height={'20px'}
                    />
                  </div>
                )}
              </>
            )}
          </React.Fragment>
        )}
      </Main>
    </React.Fragment>
  );
}

// import React, { useContext, useState, useEffect } from 'react';
// import { AdminContext } from '../../context/AdminContext';
// import Login from '../Login';
// import CookieFunction from '../../functions/cookieFunction';
// import Api from '../../api';
// import useWindowDimensions from '../../functions/UseWindowDimensions';
// import moment from 'moment';
// import ChooseLanguage from '../../functions/chooseLanguage';
// import CheckToken from '../../functions/CheckToken';
// import Main from '../Main';

// export default function Layout() {
//   const {
//     userInfo,
//     setUserInfo,
//     setVideoChatSize,
//     setVideoType,
//     setImageType,
//     imageType,
//     videotype,
//     showUsers,
//     setShowUsers,
//     setShowAbsolute,
//     activeUser,
//     setActiveUser,
//     userChannelId,
//     setUserChannelId,
//     themeColor,
//     setThemeColor,
//     themeMode,
//     setThemeMode,
//     content,
//     setContent,
//     direction,
//     setDirection,
//     setLang,
//     lang,
//     privateUsers,
//     setPrivateUsers,
//     fileType,
//     setFileType,
//     setActiveAudio,
//     setActiveMessage,
//     activeMessageAudio,
//     openZoomModal,
//     setOpenZoomModal,
//     zoomContent,
//     setZoomeContent,
//     downloadedFiles,
//     setDownloadedFiles,
//     showFiles,
//     setShowFiles,
//     openSettingModal,
//     setOpenSettingModal,
//     bg,
//     setBg,
//     setBackScale,
//     openCreateGroup,
//     setOpenCreateGroup,
//     setGroupState,
//     trigger,
//     setTrigger,
//   } = useContext(AdminContext);

//   // const [loginModal, setLoginModal] = useState(false);
//   // const [signUpModal, setSignUpModal] = useState(false);
//   // const [forgetPasswordModal, setForgetPasswordModal] = useState(false);
//   const [KidzyLogin, setKidzyLogin] = useState(false);
//   const [users, setUsers] = useState([]);

//   const [loadingUsers, setloadingUsers] = useState(false);
//   const [splashState, setSplashState] = useState(true);
//   const [onlineStatusLayout, setOnlineStatusLayout] = useState(true);
//   const { width, height } = useWindowDimensions();
//   const [level1, setLevel1] = useState(true);
//   const [level2, setLevel2] = useState(false);
//   const [level3, setLevel3] = useState(false);
//   const [level4, setLevel4] = useState(false);
//   const [showModal, setShowModal] = useState(false);
//   const [loginModal, setLoginModal] = useState(true);
//   const [signupModal, setSignUpModal] = useState(false);
//   const [forgetPasswordModal, setForgetPasswordModal] = useState(false);

//   const [forgetlevel1, setforgetLevel1] = useState(false);
//   const [forgetlevel2, setforgetLevel2] = useState(false);
//   const [forgetlevel3, setforgetLevel3] = useState(true);

//   useEffect(() => {
//     if (CookieFunction('get', 'ochattColor') != undefined) {
//       setThemeColor(CookieFunction('get', 'ochattColor'));
//     } else {
//       CookieFunction('set', 'ochattColor', 'green', () => {
//         setThemeColor(CookieFunction('get', 'ochattColor'));
//       });
//     }

//     if (CookieFunction('get', 'ochattMode') != undefined) {
//       setThemeMode(CookieFunction('get', 'ochattMode'));
//     } else {
//       CookieFunction('set', 'ochattMode', 'dark', () => {
//         setThemeMode(CookieFunction('get', 'ochattMode'));
//       });
//     }

//     if (CookieFunction('get', 'ochattLang') != undefined) {
//       setContent(ChooseLanguage(CookieFunction('get', 'ochattLang'))?.content);
//       setDirection(ChooseLanguage(CookieFunction('get', 'ochattLang'))?.dir);
//       setLang(CookieFunction('get', 'ochattLang'));
//       let lang = ChooseLanguage(CookieFunction('get', 'ochattLang'));
//       moment.locale(`${lang}`);
//     } else {
//       CookieFunction('set', 'ochattLang', 'en', () => {
//         setContent(
//           ChooseLanguage(CookieFunction('get', 'ochattLang'))?.content
//         );
//         setDirection(ChooseLanguage(CookieFunction('get', 'ochattLang'))?.dir);
//         setLang('en');
//         ChooseLanguage('en');
//       });
//     }

//     if (CookieFunction('get', 'ochattBg') != undefined) {
//       setBg(CookieFunction('get', 'ochattBg'));
//     } else {
//       CookieFunction('set', 'ochattBg', '0', () => {
//         setBg('0');
//       });
//     }

//     if (CookieFunction('get', 'backScale') != undefined) {
//       setBackScale(CookieFunction('get', 'backScale'));
//     } else {
//       CookieFunction('set', 'backScale', '41', () => {
//         setBackScale('41');
//       });
//     }
//     //   if (typeof window !== 'undefined' && typeof document !== 'undefined') {
//     let isLogin = CheckToken(CookieFunction('get', 'ochattToken'));
//     console.log('islogin', isLogin);
//     console.log(
//       'udata',
//       CookieFunction('get', 'ochattToken'),
//       CookieFunction('get', 'userAuthOchatt'),
//       CookieFunction('get', 'ochattColor')
//     );
//     if (isLogin) {
//       Api.checkLogin().then((res) => {
//         if (res.data.response.status == 403 && isLogin) {
//           exitFunction();
//         } else {
//           // userInfoFunction();
//         }
//       });
//     }
//     setTimeout(() => {
//       setSplashState(false);
//     }, 3000);
//     // window.electron.ipcRenderer.on('app-will-close', (event) => {
//     //   // do something before app closes
//     //   // });
//     //   // alert('1');
//     //   // window.electron.ipcRenderer.once('if-close', (event, data) => {

//     //   console.log('hello', socketRef, userChannelId);

//     //   if (token == undefined || !token) {
//     //     setUserChannelId('');
//     //     window.electron.ipcRenderer.sendMessage('acceptClose', []);
//     //   }
//     // });
//   }, []);

//   return (
//     <div>
//       <Main className={`${direction} relative`}>
//         <Login
//           setLoginModal={setLoginModal}
//           setSignUpModal={setSignUpModal}
//           setForgetPasswordModal={setForgetPasswordModal}
//           setKidzyLogin={setKidzyLogin}
//           content={content}
//         />
//       </Main>
//     </div>
//   );
// }
